export interface Device {
  identifier: string;
  name: string;
  deviceId: string;
  os: Platform;
  osVersion: string;
  model: string;
  logs: {
    battery: string;
  };
  batteryLog: {
    batteryStart: BatteryRecord;
    batteryLevelChange: BatteryRecord[];
    batteryEnd: BatteryRecord;
  };
  systemState?: {
    osVersion: string;
    batteryLogging?: boolean;
  }
  batteryReady: boolean;
  batteryStart: number;
  batteryEnd: number;
  batteryChange: number;
  DPH: number;
  sdkDPH?: number;
  totalDrain: number;
  batteryStartTime: Date;
  batteryEndTime: Date;
  survivability: boolean;
}

export interface BatteryRecord {
  batteryPercentage: number;
  time: string;
}

export interface GraphDataPoint {
  isShowing: boolean;
  name: string;
  percentage: number;
  platform: Platform;
  time: Date;
}

export enum Platform {
  BOTH = "Both",
  IOS = "iOS",
  ANDROID = "Android",
  UNKNOWN = "Unknown"
}

export interface TestInstance {
  _id: string;
  name: string;
  scenarioId: string;
  devices: Device[];
  mode: string;
  duration: any;
  sdkVersion: string;
  comments: string;
  isProduction: boolean;
  enableBackgroundLocationIndicator: boolean;
  enableBGMode: boolean;
  isValid: boolean;
  status: string;
  state: string;
  lastUpdateTime: string;
  creationTime: string;
  trackedLocations: any[];
  scenario: any;
}

export interface GraphLine {
  name: string;
  isShowing: boolean;
  model: string;
  osVersion: string;
  values: {
    time: string;
    percentage: number;
  }[];
  totalDrain?: number;
  stackedDPH?: number;
  sdkDPH?: number;
}
